import BasicLayout from '@/layouts/Basic';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';

export default [
    {
        path: '/user/:userid/coupon',
        component: BasicLayout,
        children: [
            {
                path: 'manage',
                name: 'couponManageOld',
                redirect: '/user/:userid/userCenter/coupon',
                meta: {
                    // authorizedRole: 'digital_view_coupon'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('Coupon', () =>
                    import('../model/Coupon')
                ),
                component: () => import('@/views/Coupon/index')
            }
        ]
    }
];
